// Yarn Count List
import React, { useEffect, useState, useRef } from 'react';
import YarnCountService from '../../services/yarn-count.service';
import './yarn-count-list.scss';
import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  PdfExport,
  PdfExportProperties,
  ExcelExport,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  Group,
  GroupSettingsModel,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  Freeze,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
  CommandColumn,
  CommandModel,
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import YarnCountAdd from './yarn-count-add';
import YarnCountEdit from './yarn-count-edit';
// import YarnPurchaseContractEdit from './yarn-purchase-contract-edit';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
// import YarnContractDeliveryScheduleList from '../yarn-contract-delivery-schedule/yarn-contract-delivery-schedule-list';
import moment from 'moment';
import SecurityService from '../security/security.service';
import { useMemo } from 'react';
import AuditTableInput from '../audit-table/audit-table';
import HardDelete from '../hard-delete/hard-delete';

let selectedRows = []

export default function YarnCountList(props) {
  const [yarnCount, setYarnCount] = useState([]);
  // const [showDialog, setShowDialog] = useState(false);
  // const [selectedRow, setSelectedRow] = useState({});

  const [deleteDialogVisibility, setDeleteDialogVisibility] = useState(false);
  const [dialogWarningVisibility, setDialogWarningVisibility] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const deleteDialog = useRef();
  const warningDialog = useRef();
  const [showDialogs, setShowDialogs] = useState();
  const [deletingProps, setDeletingProps] = useState();

  const [deletingID, setDeletingID] = useState(0);
  let yarnCountGrid: Grid;

  const userId = SecurityService.getLoggedInUserId();

  const toolbarClick = (args: ClickEventArgs) => {
    console.log('args.item.properties :', args.item.properties);
    if (
      yarnCountGrid &&
      args.item.properties.id === 'yarnCountGrid_PDFExport'
    ) {
      const exportProperties: PdfExportProperties = {
        pageOrientation: 'Landscape',
        fileName: `${moment().format('YYYYMMDD')}_yarn_count.pdf`

      };
      console.log('clicked on pdf export');
      yarnCountGrid.pdfExport(exportProperties);
    }
    if (
      yarnCountGrid &&
      args.item.properties.id === 'yarnCountGrid_excelexport'
    ) {
      const exportProperties: PdfExportProperties = {
        fileName: `${moment().format('YYYYMMDD')}_yarn_count.xlsx`
      };
      yarnCountGrid.excelExport(exportProperties);
    }
    if (
      yarnCountGrid &&
      args.item.properties.id === 'yarnCountGrid_columnchooser'
    ) {
    }
    if (yarnCountGrid && args.item.properties.id === 'Delete') {
      console.log('toolbar Delete');
      if (yarnCountGrid.selectedRowIndex === -1) {
        // no rows selected
        console.log('Delete ', yarnCountGrid.getSelectedRecords()[0]);
        // setDialogWarningVisibility(false);
        let obj={
          TableName:`YarnCount`,
          ColumnName:`YarnCountID`,
          RowID:undefined,
          SelectedRow:false
          
        }
        setDeletingProps(obj)
        // setShowDialogs(true)
        setWarningMessage("Please select a row first!");
        warningDialog.current.show();

      } else {
        console.log('delete: ', yarnCountGrid.getSelectedRecords())
        console.log(selectedRows)
        // deleteDialog.current.hide();
        let obj={
          TableName:`YarnCount`,
          ColumnName:`YarnCountID`,
          RowID:yarnCountGrid.getSelectedRecords()[0]['YarnCountID'],
          SelectedRow:true,
          SelectedRowData:{
            YarnCount:  yarnCountGrid.getSelectedRecords()[0].YarnCount,
            WarpWastagePercent: yarnCountGrid.getSelectedRecords()[0].WarpWastagePercent,
            WeftWastagePercent: yarnCountGrid.getSelectedRecords()[0].WeftWastagePercent
          }

          
          }
          setDeletingProps(obj)
        
        // deleteDialog.current.show();
        setShowDialogs(true)
      }
    } 
    
    // if (
    //   transporterGrid &&
    //   args.item.properties.id === 'transporterGrid_Delivery Schedule'
    // ) {
    //   console.log('clicked delivery');
    // }
  };

  useEffect(() => {
    getYarnCount();
  }, []);

  const getYarnCount = async () => {
    YarnCountService.getAll()
      .then((response) => {
        console.log('get all yarn count', response)
        setYarnCount(response.data.recordset);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const addYarnCount = () => {
    props.history.push('/YarnCount/Add');
  };

  const getRoute = () =>
    window.location.pathname
      .substr(1, window.location.pathname.length)
      .split('/');

  const toolbarOptions: ToolbarItems[] = [
    'Add',
    'Edit',
    {
      text: "Delete",
      tooltipText: "Delete",
      id: "Delete",
      disabled: !SecurityService.canUserAccess('YarnCountDelete'),
    },
    'Update',
    'Cancel',
    'PDFExport',
    'ExcelExport',
    'Search',
    'ColumnChooser',
  ];

  const databound = () =>
  {
      if (yarnCountGrid) {
        yarnCountGrid.autoFitColumns();
      }
  }


  // Grey Area
  const dialogTemplate = (props) => {
    console.log('props: ', props);
    return props.isAdd ?
      (
        <YarnCountAdd dataList={yarnCount} {...props} > </YarnCountAdd>
      )
      :
      (
        <YarnCountEdit dataList={yarnCount} {...props}> </YarnCountEdit>
      );
    // (
    //   <TransporterEdit {...props}></TransporterEdit>
    // );
  };

  const editSettings: EditSettingsModel = {

    allowEditing: SecurityService.canUserAccess('YarnCountEdit'),
    allowAdding: SecurityService.canUserAccess('YarnCountAdd'),
    allowDeleting: SecurityService.canUserAccess('YarnCountDelete'),

    // allowEditing: true,
    // allowAdding: true,
    // allowDeleting: true,

    mode: 'Dialog',
    // showDeleteConfirmDialog: true,
    template: dialogTemplate,
    headerTemplate: '<p></p>',
  };

  const filterOptions: FilterSettingsModel = {
    type: 'Excel',
    // columns: [
    //   {
    //     field: 'IsDeleted',
    //     operator: 'notequal',
    //     value: 'True'
    //   }
    // ]
  };

  const groupOptions: GroupSettingsModel = {
    showDroopArea: true,
  };

  const sortingOptions: SortSettingsModel = {
    columns: [{ field: 'YarnCountID', direction: 'Descending' }]
  }

  const footerSum = (e: any) => {
    return <span> Sum: {e.Sum}</span>;
  };

  const DELETE_MESSAGE = "DELETED SUCCESSFULLY";
  const CONFLICT_MESSAGE = "CONFLICT IN DATABASE";
  const deleteRow = () => {
    YarnCountService.delete(deletingID)
      .then((response) => {
        console.log(response);
        setWarningMessage(DELETE_MESSAGE);
        warningDialog.current.show();
      })
      .catch((e) => {
        setWarningMessage(CONFLICT_MESSAGE);
        warningDialog.current.show();
      });
  };

  const deleteButtons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: (e) => {
        deleteDialog.current.hide();
        console.log(e);
        deleteRow();
      },
    },
    {
      buttonModel: {
        content: "Cancel",
        cssClass: "e-flat",
      },
      click: () => {
        deleteDialog.current.hide();
      },
    },
  ];

  const warningButtons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        warningDialog.current.hide();
        // setTimeout(() => {
        //   if (!(warningMessage.includes('access denied'))) {
        //     // record was succesfully deleted
        //     const type = getRoute()[1];
        //     getYarnContracts(type);
        //     // console.log("record was succesfully deleted");
        //   }
        // }, 500);
      },
    },
  ];

  function deleteDialogClose() {
    setDeleteDialogVisibility(false);
  }

  function warningDialogClose() {
    setDialogWarningVisibility(false);
    if (warningMessage.includes(DELETE_MESSAGE)) {
      getYarnCount();
    }
  }

  // const header = () => {
  //   return <div>Yarn Contract Delivery Schedule</div>;
  // };

  //   const contentTemplate = () => {
  //     <div>
  //       <YarnContractDeliveryScheduleList
  //         {...selectedRow}
  //       ></YarnContractDeliveryScheduleList>
  //     </div>
  //   );
  // };

  const actionComplete = (args: DialogEditEventArgs) => {
    console.log('data: ', args);
    if (args?.requestType === 'columnstate') {
      console.log('adjusting column');
      yarnCountGrid?.autoFitColumns();
    }
    if (args.form) {
      console.log('data: ', args);
      if (args.requestType === 'beginEdit' || args.requestType === 'add') {
        console.log('e: ', args.form.ej2_instances[0]);
        /** Add Validation Rules */

        args.form.ej2_instances[0].addRules('YarnCount', {
          required: true,
        });

        args.form.ej2_instances[0].addRules('WarpWastagePercent', {
          required: true,
        });

        args.form.ej2_instances[0].addRules('WeftWastagePercent', {
          required: true,
        });

      }

      if (args?.action === 'add' && args?.requestType === 'save') {
        console.log('Adding ......');
        const data = {
          UserId: userId,
          ...args.data
        };
        console.log('add data: ', data);
        YarnCountService.create(data).then((response) => {
          console.log('add response: ', response);
          let AddData = {
            YarnCount: args.data.YarnCount,
            WarpWastagePercent: args.data.WarpWastagePercent,
            WeftWastagePercent: args.data.WeftWastagePercent
          }
          AuditTableInput.auditAdd(`YarnCount`,`YarnCount`,`YarnCountID`,AddData)
          setYarnCount(response.data.recordset);
          // refresh grid to show new record
          // const type = getroute()[1];
          getYarnCount();
        });
      } 
      if (args?.action === 'edit' && args?.requestType === 'save') {
        console.log('Updating ......');
        const data = {
          UserId: userId,
          ...args.data,
          UserID:userId,
          YarnCountId:args.data.YarnCountID
        };
        console.log('update data: ', data);
        YarnCountService.update(data).then((response) => {
          console.log('update response: ', response);
          let EditData = {
            YarnCount: args.data.YarnCount,
            WarpWastagePercent: args.data.WarpWastagePercent,
            WeftWastagePercent: args.data.WeftWastagePercent
          }
          let totalColumns = Object.keys(EditData);
          console.log(totalColumns)

          AuditTableInput.auditEdit(totalColumns,selectedRows,EditData,`YarnCount`,args.data.YarnCountID)
          setYarnCount(response.data.recordset);
          // refresh grid to show new record          
          getYarnCount();

        });
      }      
    }

  };


  const thousandSeperator = (field: string, data: object, column: Column) => {
    const value = data[column.field];
    console.log(value);
    if (value) {
        let parts = value.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
    }
  }

  // const commandClick = (args: CommandClickEventArgs) => {
  //   setShowDialog(false);
  //   console.log('command click args: ', args);
  //   setSelectedRow(args.rowData);
  //   setShowDialog(true);
  // };

  // const commands: CommandModel[] = [
  //   {
  //     buttonOption: {
  //       content: 'Delivery Schedule',
  //       cssClass: 'e-flat',
  //     },
  //   },
  // ];

  // const dialogClose = () => {
  //   this.buttonInstance.style.display = 'inline-block';
  //   setShowDialog(false);
  // };

  // const openDialog = () => {
  //   setShowDialog(true);
  // };

  const YarnCountGridComponent = useMemo(() => ({ restrictPageSize = 12 }) => (
    <GridComponent
      ref={(grid) => (yarnCountGrid = grid)}
      id='yarnCountGrid'
      dataSource={yarnCount}
      editSettings={editSettings}
      toolbar={toolbarOptions}
      pageSettings={{ pageCount: 4, pageSizes: true, pageSize: restrictPageSize }}
      filterSettings={filterOptions}
      groupSettings={groupOptions}
      actionComplete={actionComplete}
      allowTextWrap='true'
      // commandClick={commandClick}

      allowPaging={true}
      allowSorting={true}
      allowPdfExport={true}
      allowExcelExport={true}
      toolbarClick={toolbarClick}
      allowFiltering={true}
      allowGrouping={true}
      showColumnChooser={true}
      allowReordering={true}
      allowResizing={true}
      sortSettings={sortingOptions}
     dataBound={databound}

     rowSelected={
      (args)=>{
        console.log(args.data)
       selectedRows = args.data 
        
                  setTimeout(() => {
          console.log('ss')
        }, 200);
      }
    }

    >
      <ColumnsDirective>
        {/* <ColumnDirective
                headerText='Commands'
                width='170'
                commands={commands}
                textAlign='Left'
              /> */}

        
<ColumnDirective
          headerText='ID'
          field='YarnCountID'
          width='100'
          headerTextAlign='Center'
          textAlign='Right'
        />
        {/* <ColumnDirective
                headerText='Order Date'
                field='OrderDate'
                width='200'
                
                type='date'
                format='dd/MM/yy'
              /> */}
        <ColumnDirective
          headerText='Yarn Count'
          field='YarnCount'
          width='100'
          headerTextAlign='Center'
          textAlign='Right'
          valueAccessor={thousandSeperator}
        />
        <ColumnDirective
          headerTextAlign='Center'
          textAlign='Right'
          headerText='Warp Wastage %'
          field='WarpWastagePercent'
          width='100'
          format='n2'
       //   valueAccessor={thousandSeperator}
          
        />
        <ColumnDirective
          headerTextAlign='Center'
          textAlign='Right'
          headerText='Weft Wastage %'
          format='n2'
          field='WeftWastagePercent'
          width='100'
        //  valueAccessor={thousandSeperator}
        />
        {/* <ColumnDirective
                headerText='Account Manager'
                field='IsAccountManager'
                width='200'
              />
              <ColumnDirective
                headerText='Export Manager'
                field='IsExportManager'
                width='140'
              />
              <ColumnDirective
                headerText='Resignation Date'
                field='ResignationDate'
                width='200'
                type='date'
                format='dd/MM/yy'
              />
              <ColumnDirective
                headerText='Designation Name'
                field='DesignationName'
                width='150'
              /> */}
        {/* <ColumnDirective
                headerText='Bags Ordered'
                field='OrderBags'
                width='150'
              />
              <ColumnDirective
                headerText='Designation Name'
                field='Designation Name'
                width='150'
              />
              <ColumnDirective
                headerText='Procurement Type'
                field='ProcurementType'
                width='150'
              />
              <ColumnDirective
                headerText='Start Date'
                field='ContractStartDate'
                width='150'
                type='date'
              />
              <ColumnDirective
                headerText='End Date'
                field='ContractEndDate'
                width='150'
                type='date'
              />
              <ColumnDirective
                headerText='Currency'
                field='CurrencyName'
                width='140'
              />
              <ColumnDirective
                headerText='Foreign Currency Rate'
                field='ForeignCurrencyRate'
                width='200'
              />
              <ColumnDirective
                headerText='Foreign Currency Amount'
                field='ForeignCurrencyAmount'
                width='200'
              />
              <ColumnDirective
                headerText='Contract Exchange Rate'
                field='ContractExchangeRate'
                width='200'
              />
              <ColumnDirective
                headerText='Bags Received'
                field='ReceivedBags'
                width='140'
              />
              <ColumnDirective
                headerText='Bags Returned'
                field='ReturnedBags'
                width='140'
              />
              <ColumnDirective
                headerText='Tax %'
                field='TaxPercent'
                width='100'
              />
              <ColumnDirective
                headerText='Tax Type'
                field='TaxType'
                width='150'
              /> */}
      </ColumnsDirective>

      {/* <AggregatesDirective>
              <AggregateDirective>
                <AggregateColumnsDirective>
                  <AggregateColumnDirective
                    field='OrderBags'
                    type='Sum'
                    footerTemplate={footerSum}
                  />
                </AggregateColumnsDirective>
              </AggregateDirective>
              <AggregateDirective>
                <AggregateColumnsDirective>
                  <AggregateColumnDirective
                    field='OrderBags'
                    type='Sum'
                    groupFooterTemplate={footerSum}
                  />
                </AggregateColumnsDirective>
              </AggregateDirective>
            </AggregatesDirective> */}

      <Inject
        services={[
          Edit,
          Toolbar,
          Page,
          Sort,
          PdfExport,
          ExcelExport,
          Filter,
          Group,
          Aggregate,
          Freeze,
          ColumnChooser,
          Reorder,
          Resize,
          // CommandColumn,
        ]}
      />
    </GridComponent>
  ), [yarnCount]);

  

  const DeleteDialogComponent = () => (
    <div>
      <DialogComponent
        ref={deleteDialog}
        width={500}
        visible={deleteDialogVisibility}
        close={deleteDialogClose}
        content={() => <div>Are you sure you want to delete?</div>}
        isModal={true}
        header="Confirmation"
        buttons={deleteButtons}
      // footerTemplate={footerTemplate}
      />
      <DialogComponent
        ref={warningDialog}
        width={400}
        visible={dialogWarningVisibility}
        close={warningDialogClose}
        content={() => <div>{warningMessage}</div>}
        isModal={true}
        header="Warning"
        buttons={warningButtons}
      // footerTemplate={footerTemplate}
      />
    </div>
  );

  return (
    (props.isDialog) ? (
      <div>
        <DeleteDialogComponent />
        <YarnCountGridComponent restrictPageSize={5} />
      </div>
    ) :
      (
        <div className="content-wrapper">
          <div>
            
          {showDialogs ?
          <HardDelete
            {...deletingProps} 
            showResult={(e)=>{
                                console.log(e)

                                setShowDialogs(false)
                                if(e == false){
                                  setShowDialogs(false)
                                  // setProcessingDetails(
                                  //   processingDetails.filter(
                                  //     (item) => item?.FabricProcessingContractDetailID !== deletingID
                                  //   )
                                  // );

                                  //  fabricProcessingContractGrid.dataSource[args?.rowIndex] =   args?.data;
        // console.log("save: ", data);
        // FabricProcessingContractService.create(data);
        setTimeout(() => {
          
          // yarnCountGrid.refresh()
          getYarnCount();

        }, 200);
      // getProductCutSize(props.path.substring(1));

                                  // const type = getRoute()[1];
                                  // getProcessDesc(type);
                                }
              }} 
                ></HardDelete>
                  :null}

            <div>
              <h3>Yarn Count - List</h3>
              <DeleteDialogComponent />
              <div>
                {/* <ButtonComponent onClick={addYarnContract}>Add </ButtonComponent> */}
                {/* <button
                  className='m-3 btn btn-sm btn-primary'
                  onClick={this.addYarnContract}
                >
                  Add
                </button> */}
              </div>
              {/* <div>
                <ReactDataGrid columns={columns} rows={rows} editor={true} />
              </div> */}

              {/* <div className='e-statustext'>
                    Select column name to toggle visibility
                  </div> */}
              {/* <ToolbarComponent
                    id='toolbar'
                    ref={(toolbar) => (this.ToolbarInstance = toolbar)}
                    onClick={toolBarClick(this)}
                  >
                    <ItemsDirective>
                      <ItemDirective text='Order ID' />
                      <ItemDirective text='Customer Name' />
                      <ItemDirective text='Freight' />
                      <ItemDirective text='Order Date' />
                      <ItemDirective text='Shipped Date' />
                      <ItemDirective text='Ship Country' />
                    </ItemsDirective>
                  </ToolbarComponent> */}
              {/* <div className='App' id='dialog-target'>
              <DialogComponent
                width='600px'
                target='#dialog-target'
                visible={showDialog}
                close={dialogClose}
                content={contentTemplate}
                isModal={true}
                showCloseIcon={true}
                header={header}
                
              />
            </div> */}

              <YarnCountGridComponent />
            </div>
          </div>
        </div>
      )
  );
}
